
<div class="alert alert-danger" *ngIf="loginError!==null">
  <i class="fa-icon fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;
  <strong>{{loginError.loginFailedStrongPartErrorMessage}}</strong>{{loginError.loginFailedNormalPartErrorMessage}}
  <a class="login-failed-link-message" *ngIf="loginError.loginFailedLinkPartErrorMessage"
    [routerLink]="['/user/checkstatus']" [queryParams]="{ account: 'locked'}">
    {{loginError.loginFailedLinkPartErrorMessage}}
  </a>
</div>
